/**
 * **当前账本**（`session.ledgerId` → `LedgerSummary`）—— 🔴 端侧唯一取法
 *
 * ## 为什么单独一个 hook
 * 至少有四处需要"当前账本"的字段：本币（`baseCurrency` · `DR-036` 的金额渲染）、
 * **账本时区**（`timezone` · 一切"哪一天"的判定，架构 §4.5）、账本名、切换账本。
 * 若各自写一遍 `ledgers.data?.find(l => l.id === session.ledgerId)`，
 * 就是同一事实的多份实现 —— 而它们**都不会报错**，只是某个页面偶尔找不到账本（静默）。
 *
 * ## 🔴 返回 `null` = 「还不知道」，**不要用默认值兜底**
 * 与 `useBaseCurrency()` 同一条纪律（㉘ 批）：账本列表还没回来时返回 `null`，
 * 调用方**拒绝渲染**依赖它的内容 —— 拿 `'CNY'` / `'Asia/Shanghai'` 兜底会把"不知道"
 * 伪装成"确实是这个值"，而那是最坏的一种失败（它看起来是对的）。
 */

import { useQuery } from '@tanstack/react-query';
import type { LedgerSummary } from '@jiaying/shared';
import { listLedgers } from '../api/endpoints.js';
import { useApp } from './store.js';

export function useCurrentLedger(): LedgerSummary | null {
  const { session } = useApp();
  const ledgers = useQuery({ queryKey: ['ledgers'], queryFn: listLedgers });
  const ledgerId = session?.ledgerId ?? '';
  return ledgers.data?.find((l) => l.id === ledgerId) ?? null;
}
